import api from './client';

export interface AssistantResponse {
  answer: string;
  quickFacts: {
    accounts: number;
    healthyAccounts: number;
    pendingReviews: number;
    failedJobs: number;
    queuedJobs: number;
    scheduledPosts: number;
  };
  sources: string[];
}

export async function askSocialOpsAssistant(workspaceId: string, message: string): Promise<AssistantResponse> {
  return api.post('/assistant/social-ops', { workspaceId, message });
}
